import { useEffect, useState } from "react";
import { api } from "../../../api/client.js";
import type { V4Bank } from "./deep-research-api.js";

/**
 * V4's board, unchanged: `site/template.html` filled by the build_board port (server side) and shown in a sandboxed frame (scripts only, no same-origin:
 * it cannot reach the session or the API; V4's theme storage falls back silently, as its own try/catch allows). Picks are written down by #number, as in V4,
 * and entered in the selection below.
 */
export function DeepResearchBoard({ tenantId, bank, refreshKey }: { readonly tenantId: string; readonly bank: V4Bank; readonly refreshKey: number }) {
  const [html, setHtml] = useState<string | null>(null);
  const [counts, setCounts] = useState<{ reels: number; stills: number; accounts: number; dbReels: number } | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    setHtml(null); setError(null);
    api.get<{ html: string; counts: { reels: number; stills: number; accounts: number; dbReels: number } }>(`/research/v4/${encodeURIComponent(tenantId)}/board?bank=${bank}`)
      .then((r) => { if (live) { setHtml(r.html); setCounts(r.counts); } })
      .catch(() => { if (live) setError("Could not load the board."); });
    return () => { live = false; };
  }, [tenantId, bank, refreshKey]);
  return (
    <section className="card" data-testid="dr-board">
      <h3>Board <span className="muted">({bank})</span></h3>
      {counts ? <p className="muted">Board built: {counts.reels.toLocaleString("en-US")} reels (database has {counts.dbReels.toLocaleString("en-US")}), {counts.stills.toLocaleString("en-US")} carousels and photos, {counts.accounts} accounts</p> : null}
      {error ? <p className="error">{error}</p> : null}
      {html !== null ? (
        <iframe title="V4 board" data-testid="dr-board-frame" sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox" srcDoc={html} style={{ width: "100%", height: "80vh", border: 0 }} />
      ) : !error ? <p className="muted">Loading the board…</p> : null}
    </section>
  );
}
